import { PropsWithChildren } from 'react';
import { useKeydown } from '@ardoq/hooks';
import {
  DrawerBackdrop,
  DrawerContentContainer,
  DrawerFullscreenContainer,
} from './atoms';
import { handleEscapeButtonPressed } from '@ardoq/modal';
import { FlexBox } from '@ardoq/layout';
import { DrawerContainerProps } from './types';

export const DrawerContainer = ({
  isVisible,
  orientation,
  onBackdropClick,
  onEscPress = () => {},
  hasBackdrop = true,
  id,
  ariaLabel,
  children,
}: PropsWithChildren<DrawerContainerProps>) => {
  const containerSelector = String(DrawerContentContainer);
  useKeydown(handleEscapeButtonPressed(onEscPress, containerSelector));
  return (
    <DrawerFullscreenContainer $isDrawer $hasBackdrop={hasBackdrop}>
      <FlexBox justify="flex-end" align="flex-end" width="full" height="full">
        {hasBackdrop && (
          <DrawerBackdrop onClick={onBackdropClick} $isVisible={isVisible} />
        )}
        <DrawerContentContainer
          role="dialog"
          id={id}
          aria-label={ariaLabel}
          aria-modal={isVisible && hasBackdrop}
          inert={!isVisible}
          $isVisible={isVisible}
          $orientation={orientation}
        >
          {children}
        </DrawerContentContainer>
      </FlexBox>
    </DrawerFullscreenContainer>
  );
};
